import React, { FC } from 'react';
import styled from 'styled-components';
import * as DataTableTypes from '../utils/DataTableTypes';
import { defaultBorderBottomStyles, noneBorderStyles, StyledSticky } from '../utils/DataTableStyledElements';

export interface ThProps
  extends Omit<React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>, 'css' | 'ref'> {
  border: DataTableTypes.DataTableBorder | undefined;
  resizeTableColumns: boolean;
}

export const Th: FC<React.PropsWithChildren<ThProps>> = ({ border, resizeTableColumns, ...props }) => (
  <StyledTh {...props} $border={border} $resizeTableColumns={resizeTableColumns} />
);

const StyledTh = styled(StyledSticky)<{ $border?: DataTableTypes.DataTableBorder; $resizeTableColumns: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ $resizeTableColumns }) => ($resizeTableColumns ? '12px' : '12px 24px')};
  font-weight: 500;
  font-size: 1;
  ${({ $border }) => ($border === 'none' ? noneBorderStyles : defaultBorderBottomStyles)};
  color: ${({ theme }) => theme.colorOnSurface};
  background: ${({ theme }) => theme.colorSurface};
`;
